import { KOV } from '../types';
export default {
  type: KOV,
  service: 'infura.io',
  url: 'https://kovan.infura.io/mew',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
